import * as React from 'react';
import { SVGProps } from 'react';

const IconDrillingPartLeftStrokedSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 6a5 5 0 1 0 10 0A5 5 0 0 0 1 6Zm5.5 3.969V2.031a4 4 0 0 1 0 7.938ZM2.03 6.5A4.002 4.002 0 0 0 5.5 9.969V6.5H2.031Zm.001-1A4.002 4.002 0 0 1 5.5 2.031V5.5H2.031Z"
    />
  </svg>
);
export default IconDrillingPartLeftStrokedSizeXs;
